"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decorateHeaders = void 0;
var objectAssign_1 = require("../utils/lang/objectAssign");
var sets_1 = require("../utils/lang/sets");
var FORBIDDEN_HEADERS = new sets_1._Set([
    'splitsdkclientkey',
    'splitsdkversion',
    'splitsdkmachineip',
    'splitsdkmachinename',
    'splitsdkimpressionsmode',
    'host',
    'referrer',
    'content-type',
    'content-length',
    'content-encoding',
    'accept',
    'keep-alive',
    'x-fastly-debug'
]);
function decorateHeaders(settings, headers) {
    var _a;
    if ((_a = settings.sync.requestOptions) === null || _a === void 0 ? void 0 : _a.getHeaderOverrides) {
        try {
            var headerOverrides_1 = settings.sync.requestOptions.getHeaderOverrides({ headers: (0, objectAssign_1.objectAssign)({}, headers) });
            Object.keys(headerOverrides_1)
                .filter(function (key) { return !FORBIDDEN_HEADERS.has(key.toLowerCase()); })
                .forEach(function (key) { return headers[key] = headerOverrides_1[key]; });
        }
        catch (e) {
            settings.log.error('Problem adding custom headers to request decorator: ' + e);
        }
    }
    return headers;
}
exports.decorateHeaders = decorateHeaders;
